 export const makeZebraRowStyle = ({
  selectedIds = [],
  getRowKey = (row) => row.id ?? row._id ?? row.key,
  even = '#cadcffff',
  odd = '#d5e4ffff',
  selected = '#FDE0EA',
  text = 'black',
} = {}) => {
  return (rowData, index) => {
    const key = getRowKey(rowData);
    const isSelected = selectedIds.some((id) => id === key);

    if (isSelected) {
      return {
        backgroundColor: selected,
        color: text,
        ['--row-hover']: '#a6c5ffff',
      };
    }

    const bg = index % 2 === 0 ? even : odd;
    return {
      backgroundColor: bg,
      color: text,
      ['--row-hover']: '#bad2ff',
    };
  };
};